import React from "react";
import LayoutHeader from "../inc/LayoutHeader";
import LayoutFooter from "../inc/LayoutFooter";
import { Layout } from "antd";
import PlaceOrderForm from "./PlaceOrderForm";

const OrderPage = () => {
  const { Content } = Layout;

  return (
    <Layout>
      <LayoutHeader />
      <Content>
        <PlaceOrderForm pageFrom="order_page" />
      </Content>
      <LayoutFooter />
    </Layout>
  );
};

export default OrderPage;
